export type SubtaskCreateErrorKey =
  | "subtasks.createFailed"
  | "subtasks.createUnknown"
  | "subtasks.invalidAncestor"
  | "subtasks.serverUnsupported";

export function subtaskCreateErrorKey(status: number | null): SubtaskCreateErrorKey {
  if (status === null) return "subtasks.createUnknown";
  if (status === 404 || status === 405) return "subtasks.serverUnsupported";
  if (status === 409 || status === 422) return "subtasks.invalidAncestor";
  return "subtasks.createFailed";
}

/** Reuse a key only when a transport/server failure leaves the commit outcome ambiguous. */
export function shouldRetainSubtaskIdempotencyKey(status: number | null): boolean {
  return status === null || status >= 500;
}
